// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feGaussianBlur stdDeviation=\"3\" /></filter></svg>#filter", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Text--base--wD8iFEK1 {
  color: #2c3541;
}

h1,
h2,
h3,
h4,
h5,
h6,
p,
small {
  margin: 0;
  padding: 0;
}

/* ---  h1 --- */

h1 {
  font-family: 'Larsseit-Bold';
  font-size: 30px;
  line-height: 30px
}

h1.Text--extralarge--x637Ragg {
  font-size: 36px;
}

.Text--obscure--JtTTnG0V {
  filter: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  -webkit-filter: blur(3px);
          filter: blur(3px);
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

/* ---  h2 --- */

h2 {
  font-family: 'Larsseit-Bold';
  font-weight: bold;
  font-size: 24px;
  line-height: 24px
}

h2.Text--multiline--_iZ7LsxW {
  line-height: 36px;
  font-family: 'Larsseit';
}

h2.Text--multiline--_iZ7LsxW br {
  line-height: 60px;
}

h2.Text--medium--BHQbkG5A {
  font-weight: normal;
  font-family: 'Larsseit-Medium';
}

/* ---  h3 --- */

h3 {
  font-family: 'Larsseit-Medium';
  font-size: 20px;
  line-height: 20px
}

h3.Text--multiline--_iZ7LsxW {
  line-height: 28px;
}

h3.Text--multiline--_iZ7LsxW br {
  line-height: 48px;
}

h3 small {
  font-size: 18px;
  line-height: 18px;
  font-style: inherit;
  color: inherit;
  font-family: inherit;
}

/* ---  h4 --- */

h4 {
  font-family: 'Larsseit-Light';
  font-size: 16px;
  line-height: 16px
}

h4.Text--multiline--_iZ7LsxW {
  line-height: 24px;
}

h4.Text--multiline--_iZ7LsxW br {
  line-height: 40px;
}

h4 b {
  font-family: 'Larsseit-Bold';
  font-style: inherit;
  color: inherit;
}

h4 i {
  font-family: 'Larsseit';
  font-style: inherit;
  color: inherit;
}

h4 em {
  font-family: 'Larsseit-Medium';
  font-style: inherit;
  color: inherit;
}

/* ---  h5 --- */

h5 {
  font-family: 'Larsseit-Bold';
  font-size: 14px;
  line-height: 14px;
}

.Text--LabelValue--HHrAB3ZH {
  display: inline-block;
  margin-top: 16px
}

.Text--LabelValue--HHrAB3ZH p {
  padding-top: 8px;
}

/* ---  h6 --- */

h6 {
  font-family: 'Larsseit-Medium';
  font-size: 14px;
  line-height: 14px
}

h6.Text--multiline--_iZ7LsxW {
  line-height: 22px;
}

h6.Text--multiline--_iZ7LsxW br {

  /* p line-height + multiline line-height */
  line-height: 36px;
}

/* ---  p --- */

p {
  font-family: 'Larsseit-Light';
  font-size: 14px;
  line-height: 14px
}

p.Text--multiline--_iZ7LsxW {
  line-height: 22px;
}

p.Text--multiline--_iZ7LsxW br {

  /* p line-height + multiline line-height */
  line-height: 36px;
}

p i {
  font-family: 'Larsseit';
  font-style: inherit;
  color: inherit;
}

p em {
  font-family: 'Larsseit-Medium';
  font-style: inherit;
  color: inherit;
}

p span em {
  font-family: 'Larsseit-Medium';
  font-style: inherit;
  color: inherit;
}

span em {
  font-family: 'Larsseit-Medium';
  font-style: inherit;
  color: inherit;
}

/*
p b {
  font-family: 'Larsseit-Bold';
  font-style: inherit;
  color: inherit;
}*/

a {
  font-family: 'Larsseit-Medium';
  color: #03a9f4;
  text-transform: none;
  cursor: pointer;
  text-decoration: none;
}

a:focus {
  text-decoration: none;
}

a:hover {
  color: #03a9f4;
  text-transform: none;
  text-decoration: none;
}

/* deals with link being around a p tag */

a > p {
  font-family: 'Larsseit-Medium';
}

/* this is a strict selector because this deals with <small> tags*/

p > small {
  font-family: 'Larsseit-Light';
  font-size: 12px;
  line-height: 12px;
  color: inherit
}

p > small.Text--multiline--_iZ7LsxW {
  line-height: 20px;
}

p > small.Text--multiline--_iZ7LsxW br {
  line-height: 32px;
}

p > small {

  /* deals with all the really small classes */
}

p > small.Text--smaller--j9YU7WIS {
  font-size: 11px;
  line-height: 11px;
}

p > small.Text--tiny--W7uG6YQG {
  font-size: 10px;
  line-height: 10px;
}

p > small.Text--tiny--W7uG6YQG em {
  font-family: 'Larsseit';
  font-weight: 500;
}

p > small.Text--tiny--W7uG6YQG.Text--multiline--_iZ7LsxW {
  line-height: 14px;
}

p > small.Text--micro--fjC2x_YI {
  font-family: 'Larsseit-Medium';
  font-size: 9px;
  line-height: 9px;
}

p > small.Text--micro--fjC2x_YI > i {
  font-family: 'Larsseit';
  font-size: 9px;
  line-height: 9px;
}

p > small.Text--micro--fjC2x_YI.Text--multiline--_iZ7LsxW {
  line-height: 14px;
}

p > small.Text--micro--fjC2x_YI.Text--multiline--_iZ7LsxW br {
  line-height: 23px;
}

p.Text--small--GM3kYBy1 {
  line-height: 12px !important;
  font-size: 12px !important;
}

p.Text--smaller--j9YU7WIS {
  line-height: 11px !important;
  font-size: 11px !important;
}

p.Text--tiny--W7uG6YQG {
  line-height: 10px !important;
  font-size: 10px !important;
}

p.Text--micro--fjC2x_YI {
  line-height: 9px !important;
  font-size: 9px !important;
}

p > small b {
  font-family: 'Larsseit-Bold';
  font-style: inherit;
  color: inherit;
}

p > small i {
  font-family: 'Larsseit';
  font-style: inherit;
  color: inherit;
}

p > small em {
  font-family: 'Larsseit-Medium';
  font-style: inherit;
  color: inherit;
}

/* terms */

div.Text--terms--qQEYs620 h2 {
  margin-top: 1em;
  text-align: center;
}

div.Text--terms--qQEYs620 p {
  margin: 1em 0;
  line-height: 22px;
}

/* color classes */

.Text--azure--y6VdEt6w {
  color: #03a9f4;
}

.Text--cloudGrey--zHBX9o5h {
  color: #b7c3cd;
}

.Text--coral--O2sKhCvw {
  color: #ff7043;
}

.Text--alertRed--xvsrEiWy {
  color: #ff3c2a;
}

.Text--white--HrfdHUUB {
  color: #fff;
}

.Text--seaGreen--Tv59dvOO {
  color: #13cba9;
}

.Text--neonMint--f29kHFzs {
  color: #64ffda;
}

.Text--stormySkies--v3T8811F {
  color: #5c7f98;
}

.Text--right--l6NYijWj {
  text-align: right;
}

.Text--inactive--wAoVJ2VO {
  color: #b7c3cd;
}

.Text--buttonheight--GMBw1gEJ {
  line-height: 36px !important;
}

.Text--overflowEllipsis--fwvkFqtf {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

p.Text--overflowEllipsis--fwvkFqtf > small.Text--multiline--_iZ7LsxW {
  display: block; /* Fallback for non-webkit */
  display: -webkit-box;
  height: 36px; /* Fallback for non-webkit */
  margin: 0 auto;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  white-space: initial;
}

.Text--textComponentField--kGoUbbEZ > p {
  /* SUPER specific for campaign editor text */
  line-height: normal;
}
`, "",{"version":3,"sources":["webpack://./css/themes/Text.css","<no source>"],"names":[],"mappings":"AAAA;EACE,cAAiB;AACnB;;AAEA;;;;;;;;EAQE,SAAS;EACT,UAAU;AACZ;;AAEA,gBAAgB;;AAChB;EACE,4BAA4B;EAC5B,eAAe;EACf;AAKF;;AAHE;EACE,eAAe;AACjB;;AAGF;EC3BA,gDAAA;ED4BE,yBAAiB;UAAjB,iBAAiB;EACjB,yBAAiB;KAAjB,sBAAiB;MAAjB,qBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,gBAAgB;;AAChB;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf;AAeF;;AAbE;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAGF,gBAAgB;;AAChB;EACE,8BAA8B;EAC9B,eAAe;EACf;AASF;;AAPE;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAGF;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA,gBAAgB;;AAChB;EACE,6BAA6B;EAC7B,eAAe;EACf;AASF;;AAPE;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAGF;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;;AAChB;EACE,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB;AAIF;;AAHE;EACE,gBAAgB;AAClB;;AAGF,gBAAgB;;AAChB;EACE,8BAA8B;EAC9B,eAAe;EACf;AAUF;;AARE;EACE,iBAAiB;AACnB;;AAEA;;EACE,0CAA0C;EAC1C,iBAAiB;AACnB;;AAGF,eAAe;;AACf;EACE,6BAA6B;EAC7B,eAAe;EACf;AAUF;;AARE;EACE,iBAAiB;AACnB;;AAEA;;EACE,0CAA0C;EAC1C,iBAAiB;AACnB;;AAGF;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AACA;;;;;EAKE;;AAEF;EACE,8BAA8B;EAC9B,cAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAmB;EACnB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,yCAAyC;;AACzC;EACE,8BAA8B;AAChC;;AAEA,kEAAkE;;AAClE;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB;AAiDF;;AA/CE;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAZF;;EAcE,4CAA4C;AAuC9C;;AAtCE;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAGF;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA,UAAU;;AAER;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAGF,kBAAkB;;AAElB;EACE,cAAmB;AACrB;;AAEA;EACE,cAAuB;AACzB;;AAEA;EACE,cAAmB;AACrB;;AAEA;EACE,cAAsB;AACxB;;AAEA;EACE,WAAmB;AACrB;;AAEA;EACE,cAAsB;AACxB;;AAEA;EACE,cAAsB;AACxB;;AAEA;EACE,cAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc,EAAE,4BAA4B;EAC5C,oBAAoB;EACpB,YAAY,EAAE,4BAA4B;EAC1C,cAAc;EACd,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAoB;EAApB,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB","sourcesContent":[".base {\n  color: var(--ink);\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nsmall {\n  margin: 0;\n  padding: 0;\n}\n\n/* ---  h1 --- */\nh1 {\n  font-family: 'Larsseit-Bold';\n  font-size: 30px;\n  line-height: 30px;\n\n  &.extralarge {\n    font-size: 36px;\n  }\n}\n\n.obscure {\n  filter: blur(3px);\n  user-select: none;\n}\n\n/* ---  h2 --- */\nh2 {\n  font-family: 'Larsseit-Bold';\n  font-weight: bold;\n  font-size: 24px;\n  line-height: 24px;\n\n  &.multiline {\n    line-height: 36px;\n    font-family: 'Larsseit';\n  }\n\n  &.multiline br {\n    line-height: 60px;\n  }\n\n  &.medium {\n    font-weight: normal;\n    font-family: 'Larsseit-Medium';\n  }\n}\n\n/* ---  h3 --- */\nh3 {\n  font-family: 'Larsseit-Medium';\n  font-size: 20px;\n  line-height: 20px;\n\n  &.multiline {\n    line-height: 28px;\n  }\n\n  &.multiline br {\n    line-height: 48px;\n  }\n}\n\nh3 small {\n  font-size: 18px;\n  line-height: 18px;\n  font-style: inherit;\n  color: inherit;\n  font-family: inherit;\n}\n\n/* ---  h4 --- */\nh4 {\n  font-family: 'Larsseit-Light';\n  font-size: 16px;\n  line-height: 16px;\n\n  &.multiline {\n    line-height: 24px;\n  }\n\n  &.multiline br {\n    line-height: 40px;\n  }\n}\n\nh4 b {\n  font-family: 'Larsseit-Bold';\n  font-style: inherit;\n  color: inherit;\n}\n\nh4 i {\n  font-family: 'Larsseit';\n  font-style: inherit;\n  color: inherit;\n}\n\nh4 em {\n  font-family: 'Larsseit-Medium';\n  font-style: inherit;\n  color: inherit;\n}\n\n/* ---  h5 --- */\nh5 {\n  font-family: 'Larsseit-Bold';\n  font-size: 14px;\n  line-height: 14px;\n}\n\n.LabelValue {\n  display: inline-block;\n  margin-top: 16px;\n  & p {\n    padding-top: 8px;\n  }\n}\n\n/* ---  h6 --- */\nh6 {\n  font-family: 'Larsseit-Medium';\n  font-size: 14px;\n  line-height: 14px;\n\n  &.multiline {\n    line-height: 22px;\n  }\n\n  &.multiline br {\n    /* p line-height + multiline line-height */\n    line-height: 36px;\n  }\n}\n\n/* ---  p --- */\np {\n  font-family: 'Larsseit-Light';\n  font-size: 14px;\n  line-height: 14px;\n\n  &.multiline {\n    line-height: 22px;\n  }\n\n  &.multiline br {\n    /* p line-height + multiline line-height */\n    line-height: 36px;\n  }\n}\n\np i {\n  font-family: 'Larsseit';\n  font-style: inherit;\n  color: inherit;\n}\n\np em {\n  font-family: 'Larsseit-Medium';\n  font-style: inherit;\n  color: inherit;\n}\n\np span em {\n  font-family: 'Larsseit-Medium';\n  font-style: inherit;\n  color: inherit;\n}\n\nspan em {\n  font-family: 'Larsseit-Medium';\n  font-style: inherit;\n  color: inherit;\n}\n/*\np b {\n  font-family: 'Larsseit-Bold';\n  font-style: inherit;\n  color: inherit;\n}*/\n\na {\n  font-family: 'Larsseit-Medium';\n  color: var(--azure);\n  text-transform: none;\n  cursor: pointer;\n  text-decoration: none;\n}\n\na:focus {\n  text-decoration: none;\n}\n\na:hover {\n  color: var(--azure);\n  text-transform: none;\n  text-decoration: none;\n}\n\n/* deals with link being around a p tag */\na > p {\n  font-family: 'Larsseit-Medium';\n}\n\n/* this is a strict selector because this deals with <small> tags*/\np > small {\n  font-family: 'Larsseit-Light';\n  font-size: 12px;\n  line-height: 12px;\n  color: inherit;\n\n  &.multiline {\n    line-height: 20px;\n  }\n\n  &.multiline br {\n    line-height: 32px;\n  }\n\n  /* deals with all the really small classes */\n  &.smaller {\n    font-size: 11px;\n    line-height: 11px;\n  }\n\n  &.tiny {\n    font-size: 10px;\n    line-height: 10px;\n  }\n\n  &.tiny em {\n    font-family: 'Larsseit';\n    font-weight: 500;\n  }\n\n  &.tiny.multiline {\n    line-height: 14px;\n  }\n\n  &.micro {\n    font-family: 'Larsseit-Medium';\n    font-size: 9px;\n    line-height: 9px;\n  }\n\n  &.micro > i {\n    font-family: 'Larsseit';\n    font-size: 9px;\n    line-height: 9px;\n  }\n\n  &.micro.multiline {\n    line-height: 14px;\n  }\n\n  &.micro.multiline br {\n    line-height: 23px;\n  }\n}\n\np.small {\n  line-height: 12px !important;\n  font-size: 12px !important;\n}\n\np.smaller {\n  line-height: 11px !important;\n  font-size: 11px !important;\n}\n\np.tiny {\n  line-height: 10px !important;\n  font-size: 10px !important;\n}\n\np.micro {\n  line-height: 9px !important;\n  font-size: 9px !important;\n}\n\np > small b {\n  font-family: 'Larsseit-Bold';\n  font-style: inherit;\n  color: inherit;\n}\n\np > small i {\n  font-family: 'Larsseit';\n  font-style: inherit;\n  color: inherit;\n}\n\np > small em {\n  font-family: 'Larsseit-Medium';\n  font-style: inherit;\n  color: inherit;\n}\n\n/* terms */\ndiv.terms {\n  & h2 {\n    margin-top: 1em;\n    text-align: center;\n  }\n\n  & p {\n    margin: 1em 0;\n    line-height: 22px;\n  }\n}\n\n/* color classes */\n\n.azure {\n  color: var(--azure);\n}\n\n.cloudGrey {\n  color: var(--cloudGrey);\n}\n\n.coral {\n  color: var(--coral);\n}\n\n.alertRed {\n  color: var(--alertRed);\n}\n\n.white {\n  color: var(--white);\n}\n\n.seaGreen {\n  color: var(--seaGreen);\n}\n\n.neonMint {\n  color: var(--neonMint);\n}\n\n.stormySkies {\n  color: var(--stormySkies);\n}\n\n.right {\n  text-align: right;\n}\n\n.inactive {\n  color: #b7c3cd;\n}\n\n.buttonheight {\n  line-height: 36px !important;\n}\n\n.overflowEllipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\np.overflowEllipsis > small.multiline {\n  display: block; /* Fallback for non-webkit */\n  display: -webkit-box;\n  height: 36px; /* Fallback for non-webkit */\n  margin: 0 auto;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: initial;\n}\n\n.textComponentField > p {\n  /* SUPER specific for campaign editor text */\n  line-height: normal;\n}\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `Text--base--wD8iFEK1`,
	"extralarge": `Text--extralarge--x637Ragg`,
	"obscure": `Text--obscure--JtTTnG0V`,
	"multiline": `Text--multiline--_iZ7LsxW`,
	"medium": `Text--medium--BHQbkG5A`,
	"LabelValue": `Text--LabelValue--HHrAB3ZH`,
	"smaller": `Text--smaller--j9YU7WIS`,
	"tiny": `Text--tiny--W7uG6YQG`,
	"micro": `Text--micro--fjC2x_YI`,
	"small": `Text--small--GM3kYBy1`,
	"terms": `Text--terms--qQEYs620`,
	"azure": `Text--azure--y6VdEt6w`,
	"cloudGrey": `Text--cloudGrey--zHBX9o5h`,
	"coral": `Text--coral--O2sKhCvw`,
	"alertRed": `Text--alertRed--xvsrEiWy`,
	"white": `Text--white--HrfdHUUB`,
	"seaGreen": `Text--seaGreen--Tv59dvOO`,
	"neonMint": `Text--neonMint--f29kHFzs`,
	"stormySkies": `Text--stormySkies--v3T8811F`,
	"right": `Text--right--l6NYijWj`,
	"inactive": `Text--inactive--wAoVJ2VO`,
	"buttonheight": `Text--buttonheight--GMBw1gEJ`,
	"overflowEllipsis": `Text--overflowEllipsis--fwvkFqtf`,
	"textComponentField": `Text--textComponentField--kGoUbbEZ`
};
export default ___CSS_LOADER_EXPORT___;
